// extracted by mini-css-extract-plugin
var _1 = "VoAO7EkMR7qTgtBGFf1F";
var _2 = "VoAO7EkMR7qTgtBGFf1F";
export { _1 as "ag-font", _2 as "agFont" }
